var _class, _descriptor, _DialogHolder;
function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function _initializerWarningHelper(r, e) {
  throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { notEq, or } from "truth-helpers";
import DButton from "discourse/components/d-button";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let DialogHolder = (_class = (_DialogHolder = class DialogHolder extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "dialog", _descriptor, this);
  }
  async handleButtonAction(btn1) {
    if (typeof btn1.action === "function") {
      await btn1.action();
    }
    this.dialog.cancel();
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div
      aria-labelledby={{this.dialog.titleElementId}}
      aria-hidden="true"
      id="dialog-holder"
      class="dialog-container {{this.dialog.class}}"
    >
      <div class="dialog-overlay" data-a11y-dialog-hide></div>

      {{#if this.dialog.type}}
        <div class="dialog-content" role="document">
          {{#if this.dialog.title}}
            <div class="dialog-header">
              <h3 id={{this.dialog.titleElementId}}>{{this.dialog.title}}</h3>
              <DButton
                @action={{this.dialog.cancel}}
                @title="modal.close"
                @icon="times"
                class="btn-flat dialog-close close"
              />
            </div>
          {{/if}}

          {{#if (or this.dialog.message this.dialog.bodyComponent)}}
            <div class="dialog-body">
              {{#if this.dialog.bodyComponent}}
                <this.dialog.bodyComponent
                  @model={{this.dialog.bodyComponentModel}}
                />
              {{else if this.dialog.message}}
                <p>{{htmlSafe this.dialog.message}}</p>
              {{/if}}
            </div>
          {{/if}}

          {{#if (notEq this.dialog.type "notice")}}
            <div class="dialog-footer">
              {{#each this.dialog.buttons as |button|}}
                <DButton
                  @action={{fn this.handleButtonAction button}}
                  @translatedLabel={{button.label}}
                  @icon={{button.icon}}
                  class={{button.class}}
                />
              {{else}}
                <DButton
                  @action={{this.dialog.didConfirmWrapped}}
                  @icon={{this.dialog.confirmButtonIcon}}
                  @label={{this.dialog.confirmButtonLabel}}
                  @disabled={{this.dialog.confirmButtonDisabled}}
                  class={{this.dialog.confirmButtonClass}}
                />
                {{#if this.dialog.shouldDisplayCancel}}
                  <DButton
                    @action={{this.dialog.cancel}}
                    @label={{this.dialog.cancelButtonLabel}}
                    class={{this.dialog.cancelButtonClass}}
                  />
                {{/if}}
              {{/each}}
            </div>
          {{/if}}
        </div>
      {{/if}}
    </div>
  
*/
{
  "id": "cgmJLR0+",
  "block": "[[[1,\"\\n    \"],[10,0],[15,\"aria-labelledby\",[30,0,[\"dialog\",\"titleElementId\"]]],[14,\"aria-hidden\",\"true\"],[14,1,\"dialog-holder\"],[15,0,[29,[\"dialog-container \",[30,0,[\"dialog\",\"class\"]]]]],[12],[1,\"\\n      \"],[10,0],[14,0,\"dialog-overlay\"],[14,\"data-a11y-dialog-hide\",\"\"],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"dialog\",\"type\"]],[[[1,\"        \"],[10,0],[14,0,\"dialog-content\"],[14,\"role\",\"document\"],[12],[1,\"\\n\"],[41,[30,0,[\"dialog\",\"title\"]],[[[1,\"            \"],[10,0],[14,0,\"dialog-header\"],[12],[1,\"\\n              \"],[10,\"h3\"],[15,1,[30,0,[\"dialog\",\"titleElementId\"]]],[12],[1,[30,0,[\"dialog\",\"title\"]]],[13],[1,\"\\n              \"],[8,[32,0],[[24,0,\"btn-flat dialog-close close\"]],[[\"@action\",\"@title\",\"@icon\"],[[30,0,[\"dialog\",\"cancel\"]],\"modal.close\",\"times\"]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,1],[[30,0,[\"dialog\",\"message\"]],[30,0,[\"dialog\",\"bodyComponent\"]]],null],[[[1,\"            \"],[10,0],[14,0,\"dialog-body\"],[12],[1,\"\\n\"],[41,[30,0,[\"dialog\",\"bodyComponent\"]],[[[1,\"                \"],[8,[30,0,[\"dialog\",\"bodyComponent\"]],null,[[\"@model\"],[[30,0,[\"dialog\",\"bodyComponentModel\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"dialog\",\"message\"]],[[[1,\"                \"],[10,2],[12],[1,[28,[32,2],[[30,0,[\"dialog\",\"message\"]]],null]],[13],[1,\"\\n              \"]],[]],null]],[]]],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,3],[[30,0,[\"dialog\",\"type\"]],\"notice\"],null],[[[1,\"            \"],[10,0],[14,0,\"dialog-footer\"],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"dialog\",\"buttons\"]]],null]],null],null,[[[1,\"                \"],[8,[32,0],[[16,0,[30,1,[\"class\"]]]],[[\"@action\",\"@translatedLabel\",\"@icon\"],[[28,[32,4],[[30,0,[\"handleButtonAction\"]],[30,1]],null],[30,1,[\"label\"]],[30,1,[\"icon\"]]]],null],[1,\"\\n\"]],[1]],[[[1,\"                \"],[8,[32,0],[[16,0,[30,0,[\"dialog\",\"confirmButtonClass\"]]]],[[\"@action\",\"@icon\",\"@label\",\"@disabled\"],[[30,0,[\"dialog\",\"didConfirmWrapped\"]],[30,0,[\"dialog\",\"confirmButtonIcon\"]],[30,0,[\"dialog\",\"confirmButtonLabel\"]],[30,0,[\"dialog\",\"confirmButtonDisabled\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"dialog\",\"shouldDisplayCancel\"]],[[[1,\"                  \"],[8,[32,0],[[16,0,[30,0,[\"dialog\",\"cancelButtonClass\"]]]],[[\"@action\",\"@label\"],[[30,0,[\"dialog\",\"cancel\"]],[30,0,[\"dialog\",\"cancelButtonLabel\"]]]],null],[1,\"\\n\"]],[]],null]],[]]],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[\"button\"],false,[\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/dialog-holder.0d5d21b0/node_modules/dialog-holder/components/dialog-holder.js",
  "scope": () => [DButton, or, htmlSafe, notEq, fn],
  "isStrictMode": true
}), _DialogHolder), _DialogHolder), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleButtonAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleButtonAction"), _class.prototype)), _class);
export { DialogHolder as default };